import { 
  UserCheck, 
  Lightbulb, 
  BookOpen, 
  Clock, 
  Award 
} from "lucide-react";

const reasons = [
  {
    id: 1,
    icon: UserCheck,
    title: "Expert Instructors",
    description: "Learn from industry professionals with real-world experience in CAD automation."
  },
  {
    id: 2,
    icon: Lightbulb,
    title: "Hands-on Learning",
    description: "Get practical experience through interactive exercises and real-world projects."
  },
  {
    id: 3,
    icon: BookOpen,
    title: "Comprehensive Curriculum",
    description: "Covers automation using C# programming and API integrations for AutoCAD, UG-NX, Inventor and more."
  },
  {
    id: 4,
    icon: Clock,
    title: "Time-Saving Techniques",
    description: "Learn methods to reduce manual work and improve productivity."
  },
  {
    id: 5,
    icon: Award,
    title: "Certification",
    description: "Get a certificate of completion to showcase your skills to employers."
  }
];

const WhyChooseTraining = () => {
  return (
    <section 
      data-testid="why-choose-training-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            data-testid="why-choose-training-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Why Choose Our Training?
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Industry-focused programs designed to give you practical skills and real results
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <div
              key={reason.id}
              data-testid={`training-reason-${reason.id}`}
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:border-[#06B6D4]/30 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-12 h-12 rounded-xl bg-[#2563EB]/10 flex items-center justify-center mb-4">
                <reason.icon className="w-6 h-6 text-[#2563EB]" />
              </div>

              <h3 
                className="text-lg font-semibold text-[#0F172A] mb-2"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {reason.title}
              </h3>
              <p className="text-[#0F172A]/60 text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseTraining;
